<template>
  <div class="payout-qr d-inline-flex flex-column align-items-start gap-2">
    <vue-qrcode v-if="!compact"
                :value="link"
                tag="svg"
                class="payout-qr__qr"
                style="width: 100%; border-radius: 10px"
                :options="{ width: '200px' }"/>
    <div class="d-flex align-items-center gap-xs">
      <a :href="link" target="_blank" rel="noopener noreferrer">{{ helper.trans('labels.payout_qr_open_link') }}</a>
      <copy-button :value="link"></copy-button>
    </div>
    <small v-if="!compact" class="text-secondary text-wrap">{{ helper.trans('labels.payout_qr_pay_by_qr_only') }}</small>
    <small v-else class="text-secondary text-wrap">{{ helper.trans('labels.payout_qr_short') }}</small>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import {helper} from '@/service/CommonHelper'
import CopyButton from '@/apps/public/components/CopyButton.vue'

export default defineComponent({
  name: 'PayoutQrBlock',
  components: {VueQrcode, CopyButton},
  props: {
    link: {type: String, required: true},
    compact: {type: Boolean, default: false},
  },
  setup() {
    return {helper}
  },
})
</script>
